export enum DisplayAccountConfigAs {
    Dialog,
    Inline
}
